import Header from './Header';
import React, { useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { updateData } from '../../store/slices/miscSlice';
import host from '../../global.jsx';
import { candidateAuthHeader } from '../../utils/candidateAuth';
import { getWhiteLabelFromInterview } from '../../utils/whitelabel';
import { useTheme } from "../../hooks/useTheme";

const Layout = () => {
  const location = useLocation();
  const [roundName, setRoundName] = useState('');
  const {interview_id} = useParams();
  const [candidateName,setCandidateName] = useState('');
  const [isBrandingReady, setIsBrandingReady] = useState(false);
  
  const { theme } = useTheme();
  const dispatch = useDispatch(); 

  const isWhiteLabelingEnable = useSelector((state) => state.miscSlice.whitelabelEnabled);

  useEffect(() => {
    const fetchInterviewProgress = async () => {
      try {
        const response = await fetch(`${host}/check_test_progress/${interview_id}`, {
          headers: candidateAuthHeader(interview_id),
        });
        if (!response.ok) {
          // Silently ignore cancelled interviews — child page handles the UI
          return;
        }
        const data = await response.json();
        setCandidateName(data.name)
      } catch (error) {
        // Non-fatal — header name is cosmetic
      }
    };

    fetchInterviewProgress();
  }, [interview_id]);

  // Routes running the redesigned pre-check own their own top bar (theme
  // toggle) and their own sidebar, so the shared header is suppressed there.
  // Every other candidate page keeps it.
  const PRE_CHECK_ROUTES = ['/interviewinstructions', '/codinginstructions'];
  const hidesPortalHeader = PRE_CHECK_ROUTES.some((route) =>
    location.pathname.toLowerCase().includes(route)
  );

  useEffect(() => {
    const path = location.pathname;

    switch (true) {
      case path.includes('/mcq'):
        setRoundName('Knowledge Test');
        break;
        case path.includes('/coding'):
        setRoundName('Coding');
        break;
        case path.includes('/interview'):
        setRoundName('Technical Interview');
        break;
        case path.includes('/behavioral'):
        setRoundName('Behavioural Assessment');
        break;
      default:
        setRoundName('');
    }
  }, [location.pathname]);

  useEffect(() => {
    console.log({interview_id})
    if (!interview_id) {
      setIsBrandingReady(false);
      return;
    }
    document.title = '';

    const applyBranding = (branding) => {
      if (branding?.whitelabelEnabled) {
        document.title = branding.companyName || 'GenieHire';
        const favicon = document.querySelector("link[rel='icon']");
        if (favicon && branding.logoCompact) {
          favicon.href = branding.logoCompact;
        }
      } else {
        // White-labeling disabled - restore GenieHire branding
        document.title = 'GenieHire';
        const favicon = document.querySelector("link[rel='icon']");
        if (favicon) {
          favicon.href = '/Favicon.png';  // Restore GenieHire favicon
        }
      }
    };

    const loadBranding = async () => {
      try {
        const cachedKey = `whitelabel_${interview_id}`;
        const cached = sessionStorage.getItem(cachedKey);
        
        // console.log("CACHEDDDDDDDDD", cached)
        if (cached) {
          const data =  JSON.parse(cached);
          dispatch(updateData(data));
          applyBranding(data);
          setIsBrandingReady(true);
          return;
        }

        const branding = await getWhiteLabelFromInterview(interview_id);
        dispatch(updateData(branding));
        applyBranding(branding);
        sessionStorage.setItem(cachedKey, JSON.stringify(branding));
      } catch (error) {
        console.log('White-label branding not available');
        document.title = 'GenieHire';
      } finally {
        setIsBrandingReady(true);
      }
    };

    loadBranding();

    // Cleanup: Restore GenieHire when leaving candidate portal
    return () => {
      if (!window.location.pathname.includes('/candidate/')) {
        document.title = 'GenieHire';
        localStorage.removeItem("whiteLabelStatus")
        const favicon = document.querySelector("link[rel='icon']");
        if (favicon) favicon.href = '/Favicon.png';
      }
    };
  }, [interview_id ,isBrandingReady, dispatch]);

  // Show loading screen while branding loads (prevents flicker)
  if (!isBrandingReady) {
    return (
      <div className={`${isWhiteLabelingEnable ? 'bg-[#FAF9F6]':'app-background'}`} style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div className={`animate-spin rounded-full h-12 w-12 border-b-2 ${isWhiteLabelingEnable ? 'border-blue-500' : 'border-purple-500 '} mx-auto mb-4`}></div>
          <p style={{ color:isWhiteLabelingEnable ? '#1F2937':'#D9D9D9', fontSize: '14px' }}>Loading...</p>
        </div>
      </div>
    );
  }
  return (
    <>
    <div className='app-background' style={{ height: '100vh', maxHeight: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {!hidesPortalHeader && (
        <Header candidateName={candidateName} roundName={roundName} isWhiteLabelingEnable={isWhiteLabelingEnable}/>
      )}
      <main style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
        <Outlet context={{ candidateName, roundName }} />
      </main>
    </div>
    </>
  );
};

export default Layout;
